import axios from "axios";

const state = {
  milkTypes: [],
  milkType: {},
  timePeriods: [],
  timePeriod: {},
  coffeeSizes: [],
  coffeeSize: {},
};

const getters = {
  allMilkTypeList: (state) => state.milkTypes,
  milkTypeData: (state) => state.milkType,
  allTimePeriodList: (state) => state.timePeriods,
  timePeriodData: (state) => state.timePeriod,
  allCoffeeSizeList: (state) => state.coffeeSizes,
  coffeeSizeData: (state) => state.coffeeSize,
};

const actions = {
  getMilkTypes({ commit }) {
    axios.get("/api/panelMilkType/getMilkTypeList").then((response) => {
      
      console.log("response", response);
      commit("setMilkTypes", response.data.payload);
    });
  },
  updateMilkTypeStatus({ commit }, milkType) {
    console.log("milkType", milkType);
    let milkTypeData = {
      id: milkType.id,
      active: milkType.active,
    };

    return axios
      .post(`/api/panelMilkType/postChangeActiveMilkType`, milkTypeData)
      .then((response) => {
        
        console.log("response", response);
        return response.data;
      });
  },
  getMilkType({ commit }, milkTypeId) {
    console.log("milkTypeId", milkTypeId);
    axios
      .get(`/api/panelMilkType/getMilkType/${milkTypeId}`)
      .then((response) => {
        console.log("response", response);
        commit("setMilkType", response.data.payload);
      });
  },
  updateMilkType({ commit }, milkType) {
    return axios
      .post(`/api/panelMilkType/postUpdateMilkType`, milkType)
      .then((response) => {
        
        console.log("response", response);
        return response.data;
      });
  },
  addMilkType({ commit }, milkType) {
    return axios
      .post(`/api/panelMilkType/postMilkType`, milkType)
      .then((response) => {
        
        console.log("response", response);
        return response.data;
      });
  },

  //TimePeriods
  getTimePeriods({ commit }) {
    axios.get("/api/panel/coffeetimeperiod/list").then((response) => {
      
      console.log("response", response);
      commit("setTimePeriods", response.data.payload.items);
    });
  },
  getTimePeriod({ commit }, timePeriodId) {
    console.log("milkTypeId", timePeriodId);
    axios
      .get(`/api/panel/coffeetimeperiod/detail/${timePeriodId}`)
      .then((response) => {
        console.log("response", response);
        commit("setTimePeriod", response.data.payload);
      });
  },
  updateTimePeriod({ commit }, timePeriod) {
    return axios
      .put(`/api/panel/coffeetimeperiod/update-coffee-time-period`, timePeriod)
      .then((response) => {
        
        console.log("response", response);
        return response.data;
      });
  },
  updateCoffeeSizeStatus({ commit }, coffeeSize) {
    let coffeeSizeData = {
      id: coffeeSize.id,
      active: coffeeSize.active,
    };
    console.log("coffeeSize", coffeeSizeData);
    return axios
      .post(`/api/panelCoffeeSize/postChangeActiveCoffeeSize`, coffeeSizeData)
      .then((response) => {
        
        console.log("response", response);
        return response.data;
      });
  },
  addTimePeriod({ commit }, timePeriodData) {
    let timePeriodObj = {
      timePeriod:parseFloat(timePeriodData.timePeriod),
      active:timePeriodData.active
    }
    console.log("timePerioddd", timePeriodObj);
    return axios
      .post(`/api/panel/coffeetimeperiod/create-coffee-time-period`, timePeriodObj)
      .then((response) => {
        
        console.log("response", response);
        return response.data;
      });
  },
  //CoffeeSizes
  getCoffeeSizes({ commit }) {
   return axios.get("/api/panelCoffeeSize/getCoffeeSizeList").then((response) => {
      
      console.log("response", response);
      commit("setCoffeeSizes", response.data.payload);
      return response.data.payload;
    });
  },

  getCoffeeSize({ commit }, coffeeSizeId) {
    console.log("coffeeSizeId", coffeeSizeId);
    axios
      .get(`/api/panelCoffeeSize/getCoffeeSize/${coffeeSizeId}`)
      .then((response) => {
        console.log("response", response);
        commit("setCoffeeSize", response.data.payload);
      });
  },
  addCoffeeSize({ commit }, coffeeSize) {
    console.log("coffeeSize",coffeeSize);
    return axios
      .post(`/api/panelCoffeeSize/postCoffeeSize`, coffeeSize)
      .then((response) => {
        
        console.log("response", response);
        return response.data;
      });
  },
  updateCoffeeSize({ commit }, coffeeSize) {
    // let updateCoffee = {...coffeeSize};
    // delete updateCoffee.urlPath;
    console.log("json-data",JSON.stringify(coffeeSize));
    return axios
      .post(`/api/panelCoffeeSize/postUpdateCoffeeSize`, coffeeSize)
      .then((response) => {
        
        console.log("response", response);
        return response.data;
      });
  },
};

const mutations = {
  setMilkTypes: (state, milkTypes) => (state.milkTypes = milkTypes),
  setMilkType: (state, milkType) => (state.milkType = milkType),
  setTimePeriods: (state, timePeriods) => (state.timePeriods = timePeriods),
  setTimePeriod: (state, timePeriod) => (state.timePeriod = timePeriod),
  setCoffeeSizes: (state, coffeeSizes) => (state.coffeeSizes = coffeeSizes),
  setCoffeeSize: (state, coffeeSize) => (state.coffeeSize = coffeeSize),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
